<header class="site-header" id="masthead" [ngClass]="{ scrollup: isScrolled, is_width: isWidth }">
  <div class="content-wrap d-flex space-bet align-center">
    <div class="left-content">
      <div class="logo-wrap">
        <a class="navbar-brand" [routerLink]="['/my-profile', userData?.user?.username, 'Profile']">
          <img src="{{this.api.frontendAssetsUrl}}meet-hong-kong-singles-logo-01.webp" alt="Meet Hong Kong Singles" />
        </a>

        <a class="navbar-brand high-res" [routerLink]="['/my-profile', userData?.user?.username, 'Profile']">
          <img src="{{this.api.frontendAssetsUrl}}meet-hong-kong-singles-logo-01.webp" alt="Meet Hong Kong Singles" />
        </a>
      </div>
      <div class="ham-icon" [ngClass]="{ 'is-triggred': is_show_menu }" (click)="show_menu()">
        <span></span>
      </div>
    </div>

    <div class="right-content d-flex align-center">
      <nav id="site-navigation" class="main-navigation main-menu no-dot d-flex align-center"
        [ngClass]="{ 'is-open': is_show_menu }">
        <button class="menu-toggle" aria-controls="primary-menu" aria-expanded="false">
          Primary Menu
        </button>
        <div class="menu-main-menu-container">
          <ul id="primary-menu" class="menu nav-menu" [ngClass]="{ 'active': !isuser_login }">
            <!-- <li id="menu-item-131"
            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-131">
            <a [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              (click)="close_menu()">Home <fa-icon [icon]='faheart'></fa-icon></a>
          </li>
          <li id="menu-item-3279" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3279">
            <a>Blog</a>
          </li> -->
            
            <li id="menu-item-3398" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3398"
              *ngIf="isuser">
              <a [routerLink]="['/members']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                (click)="close_menu()">Members <fa-icon [icon]='faheart'></fa-icon></a>
            </li>
          </ul>
        </div>
      </nav>

      <div class="initial_hide" *ngIf="isuser_login">
        <div class="login-wrap">
          <div class="user-login">
            <ul class="wpee-notification-links d-flex align-center">
              <li class="wpee-menu" *ngIf="isuser" (click)="viewed_tab('Message')">
                <fa-icon [icon]="faEnvelope"></fa-icon>
                <span class="count">{{total_msg}}</span>
                <!-- Use the icon in the template -->
              </li>
              <li class="wpee-menu" *ngIf="isuser" (click)=" viewed_tab('Friends');">
                <fa-icon [icon]="faUsers"></fa-icon>
                <span class="count">{{total_friends}}</span>
              </li>

              <li class="wpee-menu notification-profile-img" *ngIf="isuser">
                <a class="r-circle overflow-h">
                  <img [src]="profile_img" class="header-profile-image" (click)="navigate()"/>
                </a>
                <ul class="wpee-sub-menu no-list">
                  <li class="wpee-menu">
                    <a [routerLink]="['/my-profile', userData?.user?.username, 'Profile']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                      <fa-icon [icon]="faUsers"></fa-icon>
                      My Profile
                    </a>
                  </li>
                  <li class="wpee-menu">
                    <a (click)="viewed_tab('settings')" [ngClass]="{active: this.lastSlugPart=='settings'}"><fa-icon [icon]="facog"></fa-icon>Settings </a>
                  </li>
         
                  <li class="wpee-sub-menu">
                    <a (click)="viewed_tab('viewed')" [ngClass]="{active: this.lastSlugPart=='viewed'}">
                      <fa-icon [icon]="faeye"></fa-icon>
                      <span>I Viewed / Viewed Me</span>
                    </a>
                  </li>
                  <li class="wpee-menu">
                    <a (click)="viewed_tab('edit_form')" [ngClass]="{active: this.lastSlugPart=='edit_form'}">
                      <fa-icon [icon]="fapen"></fa-icon>
                      <span>Edit Profile</span>
                    </a>
                  </li>
                  <li class="wpee-menu" (click)="user_logout()">
                    <fa-icon [icon]="fapower"></fa-icon>
                    <span>Logout</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="login-wrap" *ngIf="!isuser">
          <div class="btn-wrap primary outline outline-primary-hover has-icon">
            <a class="header-login-btn" (click)="user_login_popup()"><fa-icon [icon]="faUsers"
                class="log_btn_icon"></fa-icon>
              Login/Register</a>
          </div>
        </div>
      </div>
      <div class="lang-wrap"></div>


    </div>
  </div>
</header>
<app-login-popup [login_popup]="login_popup" (showloginpop)="handleUserLogin($event)"
  (isuser)="setuserval($event)"></app-login-popup>